// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fast-games-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.fast-games-section .fast-games-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.fast-games-section .fast-games-wrap .fast-games-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.fast-games-section .fast-games-wrap .fast-games-box .games-grid-box {
  --grid-column-number: 4;
  --grid-gap: 2rem;
  display: grid;
  grid-template-columns: repeat(var(--grid-column-number), 1fr);
  gap: var(--grid-gap);
  margin: 4rem 0;
}
.fast-games-section .fast-games-wrap .fast-games-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
@media screen and (max-width: 991.98px) {
  .fast-games-section {
    padding: 2.5rem 0;
  }
  .fast-games-section .fast-games-wrap .fast-games-box .para-text {
    font-size: 1rem;
  }
  .fast-games-section .fast-games-wrap .fast-games-box .games-grid-box {
    --grid-column-number: 4;
    --grid-gap: 1rem;
    margin: 2.5rem 0;
  }
  .fast-games-section .fast-games-wrap .fast-games-box .btn-box {
    margin-top: 2.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .fast-games-section {
    padding: 2rem 0;
  }
  .fast-games-section .fast-games-wrap .fast-games-box .para-text {
    font-size: 0.875rem;
  }
  .fast-games-section .fast-games-wrap .fast-games-box .games-grid-box {
    --grid-column-number: 2;
    --grid-gap: 1rem;
    margin: 2rem 0;
  }
  .fast-games-section .fast-games-wrap .fast-games-box .btn-box {
    margin-top: 1.25rem;
  }
}
@media screen and (max-width: 639.98px) {
  .fast-games-section {
    padding: 2rem 0;
  }
  .fast-games-section .fast-games-wrap .fast-games-box .games-grid-box {
    --grid-column-number: 2;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FastGamesSection/FastGamesStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AAGM;EACE,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,6DAAA;EACA,oBAAA;EACA,cAAA;AADR;AAIM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAFR;AAOE;EAlCF;IAmCI,iBAAA;EAJF;EAQM;IACE,eAAA;EANR;EASM;IACE,uBAAA;IACA,gBAAA;IACA,gBAAA;EAPR;EAUM;IACE,kBAAA;EARR;AACF;AAaE;EAxDF;IAyDI,eAAA;EAVF;EAcM;IACE,mBAAA;EAZR;EAeM;IACE,uBAAA;IACA,gBAAA;IACA,cAAA;EAbR;EAgBM;IACE,mBAAA;EAdR;AACF;AAmBE;EA9EF;IA+EI,eAAA;EAhBF;EAoBM;IACE,uBAAA;EAlBR;AACF","sourcesContent":[".fast-games-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .fast-games-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .fast-games-box {\n      .para-text {\n        color: var(--black-1000);\n        font-size: 1.5rem;\n        font-weight: 400;\n        line-height: 1.4;\n      }\n\n      .games-grid-box {\n        --grid-column-number: 4;\n        --grid-gap: 2rem;\n        display: grid;\n        grid-template-columns: repeat(var(--grid-column-number), 1fr);\n        gap: var(--grid-gap);\n        margin: 4rem 0;\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .fast-games-wrap {  \n      .fast-games-box {\n        .para-text {\n          font-size: 1rem;\n        }\n\n        .games-grid-box {\n          --grid-column-number: 4;\n          --grid-gap: 1rem;\n          margin: 2.5rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .fast-games-wrap {  \n      .fast-games-box {\n        .para-text {\n          font-size: 0.875rem;\n        }\n\n        .games-grid-box {\n          --grid-column-number: 2;\n          --grid-gap: 1rem;\n          margin: 2rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .fast-games-wrap {  \n      .fast-games-box {\n        .games-grid-box {\n          --grid-column-number: 2;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
